<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="amerceVo.pkid > 0 ? '编辑' : '新建'"
      class="amerce-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="amerceVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="vm-separate">
        <el-form-item label="系统编号">
          <el-input v-model="amerceVo.billNo" placeholder="系统自动生成" disabled/>
        </el-form-item>
        <el-form-item label="登记人">
          <el-input v-model="amerceVo.creatorName" disabled/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="供应商名称" prop="supplierName">
          <el-input v-model="amerceVo.supplierName" placeholder="请选择供应商">
            <el-button slot="append" @click="$refs.supplierSelect.open()"> 选择</el-button>
          </el-input>
          <supplier-select ref="supplierSelect" @select="supplierSelect"/>
        </el-form-item>
        <el-form-item label="供应商代码">
          <el-input v-model="amerceVo.supplierCode" disabled/>
        </el-form-item>
      </div>
      <el-form-item label="地址联系人">
        <el-input v-model="amerceVo.address" type="textarea"/>
      </el-form-item>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          扣款原因
        </div>
        <el-form-item label="问题来源">
          <el-checkbox-group v-model="problemSources">
            <el-checkbox v-for="item in problemSourcesList" :key="item" :label="item">{{item}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item label="分类">
            <el-select v-model="amerceVo.problemType">
              <el-option label="结构件" :value="0"/>
              <el-option label="电子件" :value="1"/>
              <el-option label="电气件" :value="2"/>
              <el-option label="机器人物料" :value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="问题描述">
            <el-input v-model="amerceVo.problemDesc" type="textarea"/>
          </el-form-item>
        </div>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          扣款明细
        </div>
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="addDetails">
          新增明细
        </el-button>
        <el-table
            :data="amerceVo.details"
            border>
          <el-table-column prop="itemName" align="center" label="扣款项目">
            <template slot-scope="scope">
              <el-select v-model="scope.row.itemName">
                <el-option label="质量罚款（参照《质保协议》5.3条款）" :value="0"/>
                <el-option label="返工/挑选工时费" :value="1"/>
                <el-option label="生产停线损失" :value="2"/>
                <el-option label="材料损失费用" :value="3"/>
                <el-option label="运费（客户投诉补料）" :value="4"/>
                <el-option label="管理费（重新采购、问题分析处理等）" :value="5"/>
                <el-option label="其他" :value="6"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="amount" width="100" align="center" label="金额">
            <template slot-scope="scope">
              <el-input v-model="scope.row.amount" placeholder="请输入" @change="totalMoney()"/>
            </template>
          </el-table-column>
          <el-table-column prop="note" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" placeholder="请输入" autosize type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="100px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px" class="vm-separate">
          <el-form-item label="合计扣款金额">
            <el-input v-model="amerceVo.totalMoney" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="申请实际扣款金额">
            <el-input v-model="amerceVo.actualAmount" disabled/>
          </el-form-item>
        </div>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          订单附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="amerceVo.attachments"
            ref="payData1"
            :data="amerceVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";

  export default {
    name: "AmerceEdit",
    components: {SupplierSelect, UploadFile},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        problemSourcesList: ["进货检验", "交期考核", "过程检验", "让步接收", "工地反馈", "客户投诉", "治具供货问题", "其他", "逾期交付"],
        problemSources: [],
        amerceVo: {
          pkid: "",
          billNo: "",
          creatTime: "",
          creatorName: loginUtil.getName(),
          customerId: "",
          supplierName: "",
          supplierId: "",
          supplierCode: "",
          problemType: "",
          totalMoney: "",
          actualAmount: "",
          problemSources: "",
          problemDesc: "",
          attachments: [],
          details: [],
        },
        ruleValidate: {
          supplierName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.amerceVo.pkid = row.pkid;
          if (this.amerceVo.pkid > 0) {
            this.getData();
          }
        }
      },
      getData() {
        this.$http
          .get("basic", `amerces/${this.amerceVo.pkid}`)
          .then(resp => {
            this.amerceVo = resp.data;
          });
      },
      fileDelete(index) {
        this.amerceVo.attachments.splice(index, 1);
      },
      totalMoney() {
        this.amerceVo.totalMoney = this.amerceVo.details.reduce((total, item) => {
          return parseFloat(total) + parseFloat(item.amount);
        }, 0);
      },
      getDetails(row, index) {
        console.log(row);
        // this.amerceVo.details[index].materialId = row.id;
        this.amerceVo.details[index].productName = row.name;
        this.amerceVo.details[index].productModel = row.no;
      },
      addDetails() {
        this.amerceVo.details.push({
          pkid: 0,
          masterId: 0,
          itemName: "",
          amount: 0,
          note: "",
        });
        console.log(this.amerceVo.details);
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      oneDelete(index) {
        this.amerceVo.details.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.amerceVo.attachments.push(params);
        }
      },
      supplierSelect(row) {
        console.log(row);
        this.amerceVo.supplierName = row.name;
        this.amerceVo.supplierId = row.pkid;
        this.amerceVo.supplierCode = row.outerNO;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.amerceVo.problemSources = JSON.stringify(this.problemSources);
            console.log(this.amerceVo.problemSources);
            if (this.amerceVo.pkid > 0) {
              this.$http
                .put("basic", "amerces", this.amerceVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "amerces", this.amerceVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>